import React from 'react';
import cx from 'classnames';
export default (function (_ref) {
  var vm = _ref.vm;
  return /*#__PURE__*/React.createElement("div", {
    className: "prompt-line__text"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('answer-boolean', !vm.answer && 'black')
  }, "Unknown question type"));
});
//# sourceMappingURL=index.js.map
